import { render, staticRenderFns } from "./MatApp.vue?vue&type=template&id=a573d162"
import script from "./MatApp.vue?vue&type=script&lang=js"
export * from "./MatApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports